/**
 * @class SpeculationRulesWrapper
 * @classdesc A custom element that wraps the speculation rules for containing links.
 * ..primarily used for sibling products.
 * @extends HTMLElement
 */

  class SpeculationRulesWrapper extends HTMLElement {
    constructor() {
      super();
      this.rules = this.querySelector('script[data-speculation-rules]');
    }
  
    connectedCallback() {
      this.initSpeculationRules();
    }
  
    disconnectedCallback() {
      if (this.speculationRules) {
        document.head.removeChild(this.speculationRules);
      }
    }
  
    initSpeculationRules() {
      if (!this.rules) {
        console.warn('No speculation rules found');
        return;
      }
  
      if (!HTMLScriptElement.supports || !HTMLScriptElement.supports('speculationrules')) {
        console.warn('Speculation Rules API is not supported in this browser');
        this.fallbackBehavior();
        return;
      }
  
      try {
        const rulesData = JSON.parse(this.rules.textContent);
  
        this.speculationRules = document.createElement('script');
        this.speculationRules.type = 'speculationrules';
        this.speculationRules.textContent = JSON.stringify(rulesData);
  
        document.head.appendChild(this.speculationRules);
  
        console.log('Speculation rules initialized');
      } catch (error) {
        console.error('Error initializing speculation rules:', error);
        this.fallbackBehavior();
      }
    }
  
    fallbackBehavior() {
      // Use traditional prefetching
      try {
        const rulesData = JSON.parse(this.rules.textContent);
        const urls = rulesData.prefetch[0].urls;
  
        urls.forEach(url => {
          const link = document.createElement('link');
          link.rel = 'prefetch';
          link.href = url;
          document.head.appendChild(link);
        });
  
        console.log('Fallback prefetching implemented');
      } catch (error) {
        console.error('Error implementing fallback behavior:', error);
      }
    }
  }
  
  customElements.define('speculation-rules-wrapper', SpeculationRulesWrapper);